import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { updateAgent } from "../../api/apiAgents";
import { useNavigate } from "react-router-dom";
import parseError from "../../utils/parseError";

const useUpdateAgent = () => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const { mutate: updateAgentAction, isPending } = useMutation({
        mutationFn: ({ id, req }) => updateAgent(id, req),
        onSuccess: (res) => {
            const message = res?.message || "Agent updated successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["agents"] });
            queryClient.invalidateQueries({ queryKey: ["agent"] });
            navigate("/agents");
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to update agent");
        },
    });

    return { updateAgent: updateAgentAction, isPending };
};

export default useUpdateAgent;
